module.exports = __webpack_public_path__ + "img/BIDV.c7ea30c5.svg";